import { render } from "./ExitIcon.vue?vue&type=template&id=35fbd134&scoped=true"
import script from "./ExitIcon.vue?vue&type=script&lang=js"
export * from "./ExitIcon.vue?vue&type=script&lang=js"

import "./ExitIcon.vue?vue&type=style&index=0&id=35fbd134&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fbd134"]])

export default __exports__